<template>
  <a-modal
    :title="title"
    :width="modalWidth"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <a-form class="tenant-form">
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="分类编码类型">
        <a-select
          placeholder="请选择"
          v-model="selectId"
          v-decorator="['ruleType', { rules: [{ required: true, message: '请选择分类编码类型' }], initialValue: 0 }]"
        >
          <a-select-option value="1">原水</a-select-option>
          <a-select-option value="0">给水</a-select-option>
          <a-select-option value="2">污水</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="文件">
        <a-upload :file-list="fileList" :remove="handleRemove" :before-upload="beforeUpload">
          <a-button type="primary" style="margin-left: 8px" :loading="exportLoading">
            <a-icon type="upload" />选择文件
          </a-button>
        </a-upload>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
export default {
  name: 'ImportModal',
  props: {
    treeData: {
      type: Array,
      default: function () {
        return []
      }
    },
    exportUrl: {
         type: String
    }
  },
  data () {
    return {
      exportLoading: false,
      fileList: [],
      selectId: '',

      queryUrl: 'zone-metering/zone-metering',
      title: '导入',
      modalWidth: 800,
      visible: false,

      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },

      form: this.$form.createForm(this)
    }
  },
  methods: {
    handleRemove (file) {
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
    },
    beforeUpload (file, fileList) {
      this.fileList = [...this.fileList, file]
      // 限制文件只能上传一个
      this.fileList = this.fileList.slice(-1)
      return false
    },
    changeFile (info) {},
    saveFile (formData) {
      this.exportLoading = true
      this.axios({
        method: 'post',
        url: this.exportUrl,
        headers: {},
        params: {},
        data: formData
      })
        .then(response => {
          if (response.code === 0) {
            this.close()
            this.$message.success(response.message)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
        .finally(() => {
               this.exportLoading = false
        this.close()
        })
    },
    show () {
            this.exportLoading = false
      this.visible = true
      // this.init()
    },
    handleCancel () {
      this.close()
    },
    close () {
      this.visible = false
      this.fileList = []
      this.selectId = ''
      //   this.disableSubmit = false
    },
    handleOk () {
      if (!this.selectId) {
           this.$message.error('请选择一个分类编码类型')
      } else if (this.fileList.length) {
        const formData = new FormData()
        formData.append('file', this.fileList[0])
        formData.append('type', this.selectId)
        this.saveFile(formData)
      } else {
        this.$message.error('请选择上传文件')
      }
    }
  }
}
</script>

<style scoped>
</style>
